<template>
  <div class="all-models-container sm:grid sm:grid-cols-6 gap-x-4 rounded-8px box-border px-2 text-14px">
    <!-- 無數據狀態 -->
    <div v-if="summaryData?.isEmpty" class="col-span-6 text-center py-8 text-gray-500">
      <div class="w-16 h-16 mx-auto mb-4">
        <!-- 空狀態圖標 -->
        <svg class="w-full h-full opacity-50" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
        </svg>
      </div>
      <div>{{ $t('public_profiles.collection_empty.post') }}</div>
    </div>

    <!-- 統計卡片 -->
    <div 
      v-else
      v-for="(value, key, index) in summaryData?.data"
      :key="key"
      class="bg-gray-600 flex-col py-2 px-3 my-2 rounded-lg"
      :class="getColSpanClass(index)"
    >
      <!-- 標題 -->
      <div class="text-14px text-gray-200">
        {{ getSummaryTitle(key) }}
      </div>
      
      <!-- 數值和增長率 -->
      <div class="flex justify-between font-medium">
        <!-- 主要數值 -->
        <div class="text-32px">
          {{ formatValue(value, key) }}
        </div>
        
        <!-- 增長率 -->
        <div 
          class="flex items-center text-20px relative"
          :class="getGrowthRateClass(summaryData?.growth[key])"
        >
          <!-- 無限增長提示 -->
          <nav-panel
            v-if="isInfinityGrowth(summaryData?.growth[key])"
            :panel-class="'w-64'"
            class="w-5 !absolute my-0 top-0 right-0"
          >
            <template #icon>
              <span class="inline-block icon w-5 h-5"></span>
            </template>
            <template #content>
              <div class="text-12px text-center">
                {{ $t('analytics.infinity_hint', 'No growth rate if last period value is 0.') }}
              </div>
            </template>
          </nav-panel>

          <span class="rate-change">{{ summaryData?.growth[key] || '0%' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inject, computed } from 'vue'
import NavPanel from './NavPanel.vue'

export default {
  name: 'ProfileAnalyticsSummary',
  components: {
    NavPanel
  },
  setup() {
    // 從父組件注入 analytics 實例
    const analytics = inject('analytics')
    
    if (!analytics) {
      console.error('ProfileAnalyticsSummary: analytics not provided')
      return {}
    }
    
    const {
      summaryData,
      loading,
      formatValue,
      getGrowthRateClass,
      getColSpanClass
    } = analytics

    // 統計項目標題映射
    const titleMapping = {
      views: 'Views',
      revenues: 'Revenues', 
      likes: 'Likes',
      download: 'Downloads',
      saved: 'Saved'
    }

    // 獲取統計項目的標題
    const getSummaryTitle = (type) => {
      return titleMapping[type] || type
    }

    // 檢查是否為無限增長
    const isInfinityGrowth = (growthValue) => {
      return growthValue === 'Infinity' || growthValue === '' || !growthValue
    }

    // 獲取響應式的 summaryData，確保是最新的
    const reactiveSummaryData = computed(() => {
      return summaryData.value
    })

    return {
      summaryData: reactiveSummaryData,
      loading,
      formatValue,
      getGrowthRateClass, 
      getColSpanClass,
      getSummaryTitle,
      isInfinityGrowth
    }
  }
}
</script>
